import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useChosenLevel } from '../../hooks/useChosenLevel.js';

export const useRestrictionsApi = () => {
  const { id: mediaDataId } = useChosenLevel();

  return useQuery({
    ...MediaPlan.getPlanningRestrictionsQueryOptions({
      params: {
        mediaDataId,
      },
    }),
    enabled: !!mediaDataId,
  });
};
